import { useTranslation } from 'react-i18next';
import { TopSeller } from '~/types/topSellersTypes';

export default function TopSellerCompanyCard({
  topSeller,
}: {
  topSeller: TopSeller;
}) {
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;
  const logo = topSeller.user.logo?.thumbnails.logo;

  return (
    <a
      href={`${process.env.REACT_APP_BASE_URL}/${locale}/user/${topSeller.id}`}
      target="_blank"
      rel="noopener noreferrer"
      className="flex h-full flex-col items-center gap-x rounded-[12px] border border-gray bg-white p-2x transition-all duration-200 hover:border-blue"
    >
      {logo ? (
        <img
          src={logo}
          alt={topSeller.user.full_name}
          width={64}
          height={64}
          className="h-[64px] w-[64px] rounded-[8px] object-contain"
        />
      ) : (
        <div className="element-center h-[64px] w-[64px] rounded-[8px] bg-gray_light_1">
          <i
            className="inline-block bg-cover gallery-icon"
            style={{ width: '16px', height: '16px' }}
          />
        </div>
      )}
      <p
        className="w-full truncate text-center text-link text-black"
        title={topSeller.user.full_name}
      >
        {topSeller.user.full_name}
      </p>
      <p className="text-body_2 text-gray__dark_1">
        {topSeller.numberOfActiveListing} {t('leadFollowUpListingsUnit')}
      </p>
    </a>
  );
}
